import React, { useState } from 'react'
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import { AiOutlinePlus } from "react-icons/ai";

export default function Counter() {
    const [counteron,setcounteron]=useState(false);
  return (
    <ScrollTrigger onEnter={()=>setcounteron(true)} onExit={()=>setcounteron(false)}>
    <h1 style={{fontSize:"70px" ,fontFamily:"Trebuchet MS', sans-serif !important"}}>
    
    {counteron && <CountUp start={0}  end={50} duration={5} delay={0} /> } 
    <i style={{color:"green"}}> {<AiOutlinePlus/>} </i> 
    </h1>
    </ScrollTrigger>
  )
}
